export default "__VITE_ASSET__BuwZpWb5__"